<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      title="查找"
      id-key="UserId"
      :data="data"
      :get-data-func="() => {}"
      :save-func="() => {}"
      :line-form="true"
      @opened="onOpened"
      form-label-width="70px"
      :form-rules="rules"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="客户编码">
          <el-input
            type="text"
            v-model="data.TradeUnitNo"
            placeholder="请输入客户编码"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户名称">
          <el-input
            type="text"
            v-model="data.TradeUnitName"
            placeholder="请输入客户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="存货编码">
          <el-input
            type="text"
            v-model="data.ProductNo"
            placeholder="请输入存货编码"
          ></el-input>
        </el-form-item>
        <el-form-item label="存货名称">
          <el-input
            type="text"
            v-model="data.ProductName"
            placeholder="请输入存货名称"
          ></el-input>
        </el-form-item>
      </template>
      <template #footer>
        <el-button type="primary" @click="toSave">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

import { puList, puListApi, getProcess } from "@/data/production/test";
// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      data: {
        ProductClassName: "",
        ProductClassNo: "",
        TradeUnitClassNo: "",
        TradeUnitClassName: "",
        // ProductName: "",
        // ProductNo: "",
        // ClassNo: "",
        // ClassName: "",
      },
      isUpdate: false,
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/sa/discountPriceCustomer").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        rate: [{ required: true, message: "请选择被调整值" }],
        equation: [{ required: true, message: "请选择计算公式" }],
        value: [{ required: true, message: "请输入被调整值" }],
      },
    };
  },
  created() {},

  methods: {
    // 打开时获取显示显示列表
    onOpened(data) {
      console.log("data", data);
      this.isUpdate = data;
      // console.log("data", data);
      // let modeName = location.hash.split("/").slice(1).join("");
      // this.formApi.list({ type: modeName }).then((res) => {
      //   this.showList = res.Data?.map((x) => x.ShowField);
      // });
    },

    onEditOpened(data) {},
    toSave() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        //移除 null 与 "" 的值
        var data = this.$commonJs.obj.removeNullKey(this.data);
        // this.$refs.dialog.isLoading = true;
        // if (this.isUpdate) {
        //   return this.$confirm("已修改是否保存", "提示", {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning",
        //   }).then(() => {
        //     this.$parent.findList(data);
        //     this.close(true);
        //   });
        // }
        this.$parent.findList(data);
        // this.$emit("close-saved");
        this.close(true);
      });
    },
    onClosed() {
      this.showList = [];
    },
  },
};
</script>
